<template>
  <v-avatar :size="size" color="grey lighten-4">
    <v-img :src="contactPhoto" alt="avatar" aspect-ratio="1"></v-img>
  </v-avatar>
</template>

<script>
export default {
  props: ["size"],
  computed: {
    contactPhoto() {
      return require("@/assets/sv/profile.jpg");
    }
  }
};
</script>

<style>
</style>
